module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/95be8547447707daedc68ea89d7b9370.gif";